import ActionTypeCliente from "../ActionTypeCliente";
export default class BuscarClientes extends ActionTypeCliente{
    ejecutar(estado, nuevoEstado) {    
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionABuscar = !(estado.flag.sensorDeAccionABuscar);
        return nuevoEstado;
    }
}